import { Meta, Title } from "@solidjs/meta";
import { ComparePage } from "~/components/landing/ComparePage";

export default function CompareRoute() {
  return (
    <>
      <Title>Chief vs Granola, Otter & Fathom: AI Note-Taker Alternatives</Title>
      <Meta
        name="description"
        content="Comparing Granola, Otter, and Fathom? See how Chief differs: no bot, live co-editing, Linear and GitHub updates, and where each tool fits better."
      />
      <ComparePage />
    </>
  );
}
